import CustomLabel from 'Common/CustomLabel/CustomLabel';
import PayerSuperSearch from 'NewComponents/UtilityComponents/PayerSuperSearch/PayerSuperSearch';
import React from 'react'

const InsurancePlanSuperSearch = ({ searchValue, onChange, handleSelectedData, label, labelRequired, disabled, toolTip }) => {
    return (
        <div className='w-full flex flex-col gap-2'>
            {label ? <CustomLabel label={label} required={labelRequired} toolTip={toolTip}  /> : null}
            <PayerSuperSearch
                disabled={disabled}
                searchValue={searchValue}
                onChange={onChange}
                handleSelectedData={handleSelectedData}
            />
        </div>

    )
}

export default InsurancePlanSuperSearch
